import {Endpoints} from '../../../globals/api/endpoints';

export class InstitutionsEndpoints extends Endpoints {
  public static readonly INSTITUTIONS = InstitutionsEndpoints.VIEWER + '/institutions';
  public static readonly USER_INSTITUTIONS = InstitutionsEndpoints.INSTITUTIONS + '/user';
}
